import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../helpers/routes';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { getLocaleProperty } from '../utils/getLocaleProperty';
import '../utils/i18next';
import useStore from '../store/selectors/useStore';

const Breadcrumbs = () => {
	const breadcrumbs = useBreadcrumbs(routes);
	const { language, title } = useStore();

	return (
		<div className="container">
			<ul
				className={breadcrumbs.length > 1 ? 'breadcrumbs' : 'breadcrumbs none'}
			>
				{breadcrumbs.map(({ match, breadcrumb }, index) => {
					return (
						<li key={`${match.pathname}-${index}`}>
							<Link to={match.pathname}>
								{index === 2
									? title
									: getLocaleProperty(match.route, 'breadcrumb', language)}
							</Link>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default Breadcrumbs;
